import { useState, useEffect } from 'react';

import { getBrowserMediaQueryWidth } from 'shared/lib/utils';

import ScreenWidthManager from './screen-width-manager';

export const useScreenWidth = (): number => {
  const initialWidth = getBrowserMediaQueryWidth();

  const [screenWidth, setScreenWidth] = useState(initialWidth);

  useEffect(() => {
    const handleScreenSizeChange = (newScreenWidth: number) => {
      setScreenWidth(newScreenWidth);
    };

    ScreenWidthManager.subscribe(handleScreenSizeChange);

    return () => {
      ScreenWidthManager.unsubscribe(handleScreenSizeChange);
    };
  }, []);

  return screenWidth;
};
